module.exports = {
	"shared.crew.original-music-composer": "Compositor",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Publicista",
	"share-overlay.share": "Compartilhar este vídeo",
	"shared.crew.associate-producer": "Produtor associado",
	"shared.crew.assistant-editor": "Editor assistente",
	"overlay.buy-from": "Compra a partir de {price}",
	"shared.crew.agent": "Agente",
	"shared.crew.additional-photography": "Fotógrafo adicional",
	"shared.crew.sound-editor": "Editor de som",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Cabelereiro",
	"shared.crew.makeup-effects": "Efeitos de maquiagem",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Assistente de produção",
	"shared.crew.executive-producer": "Produtor executivo",
	"shared.crew.costumer": "Figurante",
	"info-overlay.cast": "elenco",
	"shared.crew.stunt-coordinator": "Coordenador de dublês",
	"shared.crew.academic-advisor": "Orientador acadêmico",
	"shared.crew.swing-gang": "Swing Gang",
	"shared.crew.best-boy": "Assistente elétrico",
	"actions.purchased": "Este vídeo é seu",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Decorador de set",
	"shared.crew.adaptation": "Adaptação",
	"shared.crew.school-administrator": "Administrador da escola",
	"shared.crew.cable-person": "Eletricista",
	"shared.crew.digital-effects": "Efeitos digitais",
	"actions.rent": "Aluguel {price}",
	"info-overlay.created-by": "Por {author}",
	"social-share.twitter": "Assista \"{title}\" em {siteUrl}",
	"shared.crew.production-designer": "Diretor de arte",
	"info-overlay.crew": "equipe",
	"shared.crew.producer": "Produtor",
	"shared.crew.2nd-unit-dir-of-photography": "Diretor de fotografia da segunda unidade",
	"shared.crew.special-effects": "Efeitos especiais",
	"actions.rented": "Alugado até {date}",
	"shared.crew.boom-operator": "Microfonista",
	"shared.crew.story": "História",
	"shared.crew.script-supervisor": "Continuista",
	"shared.crew.director": "Diretor",
	"shared.crew.choreographer": "Coreógrafo",
	"shared.crew.production-manager": "Diretor de produção",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Lead Person",
	"shared.crew.location-manager": "Location Manager",
	"shared.crew.costume-designer": "Figurinista",
	"fullscreen.exit": "Sair da tela cheia",
	"shared.crew.technical-advisor": "Consultor técnico",
	"shared.crew.editor": "Editor",
	"shared.crew.additional-grip": "Maquinista adicional",
	"actions.buy": "Compra {preço}",
	"shared.crew.assistant-camera": "Assistente de câmera",
	"shared.crew.writer": "Escritor",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Diretor colaborador",
	"fullscreen.enter": "Tela cheia",
	"shared.crew.animal-trainer": "Treinador de animais",
	"shared.crew.assistant-art-director": "Assistente do diretor de arte",
	"shared.crew.key-grip": "Maquinista chefe",
	"social-button.copy": "Copiar",
	"shared.crew.makeup-artist": "Maquiador",
	"overlay.source-error": "O vídeo não pode ser reproduzido",
	"social-button.link": "Link",
	"actions.buy-from": "Compra a partir de {price}",
	"shared.crew.art-director": "Diretor de arte",
	"shared.crew.production-coordinator": "Coordenador de produção",
	"shared.crew.co-director": "Co-diretor",
	"shared.crew.co-producer": "Co-produtor",
	"shared.crew.video-operator": "Operador de vídeo",
	"shared.crew.camera-operator": "Operador de câmera",
	"shared.crew.co-writer": "Co-escritor",
	"shared.crew.set-designer": "Designer de set",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Aderecista",
	"shared.crew.cinematographer-dp": "Cinematógrafo",
	"shared.crew.grip": "Maquinista",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Operador de som",
	"quality.label": "Qualidade",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Gaffer (Chefe elétrico)",
	"shared.crew.assistant-director": "Assistente de direção",
	"actions.subscribe": "Assine {price}/mês",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Animador",
	"shared.crew.dolly-grip": "Maquinista de Dolly",
	"shared.crew.manager": "Diretor",
	"shared.crew.2nd-assistant-director": "Segundo assistente de direção",
	"shared.crew.author-of-adapted-material": "Autor de material adaptado"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_pt.json
// module id = 2796
// module chunks = 66